import React from "react";
import { Typography, Box } from "@mui/material";
import { DEFAULT_BLUE, DEFAULT_GOLD } from "../../constant";

interface HeaderProps {
  title: string;
  subtitle?: string;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle }) => {
  return (
    <Box sx={{ padding: "20px 0" }}>
      <Typography variant="h3" align="center" gutterBottom>
        <Box component="span" sx={{ color: DEFAULT_GOLD }}>
          {title.charAt(0)}
        </Box>

        <Box component="span" sx={{ color: DEFAULT_BLUE }}>
          {title.slice(1)} <br /> {subtitle && subtitle}
        </Box>
      </Typography>
    </Box>
  );
};

export default Header;
